// src/config.js

const config = {
   // 🔗 Backend API Link (Sabse Zaroori)
  apiUrl: "https://library-api.raghuveerbhati525.workers.dev",

  // Business Details
  appName: "Laxmi Library",       // Gym ke liye: "FitLife Gym"
  branchName: "Bikaner Branch",   // Gym ke liye: "JNV Colony Branch"
  mainEmoji: "📚",                // Gym ke liye: "🏋️"
  
  // User Terminology
  userType: "Student",            // Gym ke liye: "Member"
  userTypePlural: "Students",     // Gym ke liye: "Members"
  
  // Plan Terminology
  planLabel: "Plan",              // Gym ke liye: "Package"
  
  // Receipt Prefix
  receiptPrefix: "LX",            // Gym ke liye: "FIT"
};

export default config;
